module.exports = require('./helpers/bundle-url').getBundleURL('1gihZ') + "logo-dark.ba5147f0.svg";